<template>
    <div v-show="toggler.isOpen()">
        <div class="
            fixed left:0 w:full top:94 h:56 flex ai:center jc:center bg:white box-shadow:0|0|20|#0000001A
            {p:0|32;z:calc($(header-zindex)-1)}@lg
            {p:0|240}@xl
            {top:auto;bottom:66;h:48;p:0|95;z:$(comment-zindex)}@<lg
            {p:0|16;}@<sm
        ">
            <div class="flex:1 flex gap:20">
                <div class="flex flex:1 gap:12 ai:center">
                    <div class="bg:url(image/icon_speaker.svg) bg:no-repeat w:32 h:32 bg:center"></div>
                    <div class="flex:1 color:primary overflow:hidden w:1" ref="container"></div>
                </div>
                <button class="round bg:#F8F8F8 p:8 {bg:#eaeaea}:hover" @click="hide">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M12.484 4.70615C12.8746 4.31553 12.8746 3.68115 12.484 3.29053C12.0934 2.8999 11.459 2.8999 11.0684 3.29053L7.77773 6.58428L4.48398 3.29365C4.09336 2.90303 3.45898 2.90303 3.06836 3.29365C2.67773 3.68428 2.67773 4.31865 3.06836 4.70928L6.36211 7.9999L3.07148 11.2937C2.68086 11.6843 2.68086 12.3187 3.07148 12.7093C3.46211 13.0999 4.09648 13.0999 4.48711 12.7093L7.77773 9.41553L11.0715 12.7062C11.4621 13.0968 12.0965 13.0968 12.4871 12.7062C12.8777 12.3155 12.8777 11.6812 12.4871 11.2905L9.19336 7.9999L12.484 4.70615Z" fill="#5E6472" />
                    </svg>
                </button>
            </div>
        </div>
    </div>
</template>

<script setup>
    const container = ref();

    const props = defineProps({
        items: { required: true, type: Array }
    });

    const toggler = ToggleStore().toggler("marq");

    const hide = () => {
        $(container.value).marquee("destroy");

        localStorage["CloseHeadMarquee"] = new Date().toLocaleDateString();

        toggler.close();
    };

    const show = () => {
        toggler.open();

        setTimeout(() => $(container.value).html(props.items.join("<span class=\"pr:60\"></span>")).marquee({ duration: 12000 }));
    };

    defineExpose({ hide, show });
</script>
